module.exports = __webpack_public_path__ + "static/media/schody52 - schody drewniane czarne z oswietleniem pod stopniami.ad443b0e.jpg";